import React from "react";
import { Container } from "./container";
import { cssVariables } from "./css_variables";

interface ContentProps {
  children?: React.ReactNode;
}

/**
 * Displays its children in a vertical array.
 */
export function Content(props: ContentProps) {
  const { children } = props;

  return (
    <Container center>
      <Container maxWidth={cssVariables.maxContentWidth} width="100%">
        {children}
      </Container>
    </Container>
  );
}
